<ion-tabs>
	<ion-tab-bar slot="top">
		<ion-tab-button
			*ngFor="let tab of tabs"
			[tab]="tab.href"
			[class.error]="tab.hasError"
		>
			<ion-label>{{ tab.title }}</ion-label>
		</ion-tab-button>
	</ion-tab-bar>

	<ion-footer>
		<ion-button
			expand="full"
			(click)="onClickClearAppointment()"
			class="clear-appointment-btn"
		>
			Clear Appointment
		</ion-button>
	</ion-footer>
</ion-tabs>
